module.exports = __webpack_public_path__ + "img/73e6e37447611f07432a36786f1efb53.png";